<script setup lang="ts">
import getDeliveryPlanVehicleInformation from '@/types/responses/getDeliveryPlanVehicleInformation';
import ValidationErrors from '@/components/Common/ValidationErrors.vue';
import { VueDatePicker } from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { ja } from 'date-fns/locale'
import { computed } from 'vue';

const emit = defineEmits(['update:modelValue'])

const props = withDefaults(defineProps<{
  modelValue: Date | null
  deliveryPlan: getDeliveryPlanVehicleInformation
  label: string
  minDate?: string
  maxDate?: string
  errorMessages: string[]
}>(), {
  minDate: '',
  maxDate: ''
});

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
})
</script>
<template>
  <ValidationErrors
    :messages="props.errorMessages"
  >
    <VueDatePicker
      class="mt-1 with-label"
      v-model="modelValue"
      :clearable="false"
      :formats="{ input: 'yyyy-MM-dd HH:mm' }"
      :locale="ja"
      :enableSeconds="false"
      :time-config="{ enableSeconds: true }"
      :min-date="props.minDate"
      :max-date="props.maxDate"
      teleport="body"
    >
      <template #dp-input="{ value, onInput, onFocus, onBlur }">
        <div class="dp-wrapper w-100">
          <span class="dp-label">
            {{ props.label }}
          </span>
          <input
            class="dp-input"
            :value="value"
            readonly
            @focus="onFocus"
            @blur="onBlur"
            @input="onInput"
          />
        </div>
      </template>
    </VueDatePicker>
  </ValidationErrors>
</template>
<style scoped>
.dp-wrapper {
  position: relative;
  display: inline-block;
  width: 240px;
}
.dp-label {
  position: absolute;
  top: -8px;
  left: 12px;
  background: white;
  padding: 0 6px;
  font-size: 12px;
  color: #888;
  z-index: 1;
}
.dp-input {
  width: 100%;
  padding: 14px 12px 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
}
.dp-input:hover {
  border-color: #aaaeb7;
}
</style>
